import { axiosInstance } from "../client";
import { DocumentLibrary } from "@rumble-it/common-lib/types/models/DocumentLibrary.interface";
import { DocumentLibraryItem } from "@rumble-it/common-lib/types/models/DocumentLibraryItem.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";

export interface DocumentLibraryInput {
  name: string;
  // UUID of the AiProfile that selects the embeddings provider/model (required).
  aiProfile: string;
}

export const fetchDocumentLibraries = async (): Promise<
  CollectionResponse<DocumentLibrary>
> => axiosInstance.get(`/admin/libraries`).then((response) => response.data);

export const fetchDocumentLibraryById = async (
  id: string,
): Promise<DocumentLibrary> =>
  axiosInstance.get(`/admin/libraries/${id}`).then((response) => response.data);

export const createDocumentLibrary = async (
  data: DocumentLibraryInput,
): Promise<DocumentLibrary> =>
  axiosInstance
    .post(`/admin/libraries`, data)
    .then((response) => response.data);

export const deleteDocumentLibraryById = async (id: string): Promise<null> =>
  axiosInstance
    .delete(`/admin/libraries/${id}`)
    .then((response) => response.data);

export const fetchDocumentLibraryItems = async (
  libraryId: string,
  page: number = 1,
  itemsPerPage: number = 30,
): Promise<CollectionResponse<DocumentLibraryItem>> =>
  axiosInstance
    .get(
      `/admin/libraries/${libraryId}?page=${page}&itemsPerPage=${itemsPerPage}`,
    )
    .then((response) => response.data);

export const uploadDocumentToLibrary = async (
  libraryId: string,
  file: File,
  companyId?: string,
): Promise<DocumentLibraryItem> => {
  const formData = new FormData();
  formData.append("file", file);

  if (companyId) {
    formData.append("companyId", companyId);
  }

  return axiosInstance
    .post(`/admin/libraries/${libraryId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
};

export const deleteDocumentFromLibrary = async (
  libraryId: string,
  documentId: string,
): Promise<null> =>
  axiosInstance
    .delete(`/admin/libraries/${libraryId}/documents/${documentId}`)
    .then((response) => response.data);

export const linkCompanyToDocument = async (
  libraryId: string,
  documentId: string,
  companyId: string,
): Promise<unknown> =>
  axiosInstance
    .post(`/admin/libraries/${libraryId}/documents/${documentId}/companies`, {
      companyId,
    })
    .then((response) => response.data);

export const unlinkCompanyFromDocument = async (
  libraryId: string,
  documentId: string,
  companyId: string,
): Promise<null> =>
  axiosInstance
    .delete(
      `/admin/libraries/${libraryId}/documents/${documentId}/companies/${companyId}`,
    )
    .then((response) => response.data);
